<template>
    <div class="buttons">
        <img 
            v-for="(btn, index) in buttons" 
            :key="index"
            :src="btn.src"
            :alt="btn.alt"
            @click="handleButtonClick(btn.type)"
            class="action-btn"
        />
    </div>
</template>
<script>
export default {
    name: 'ActionButton',
    props: {
        onClick: {
            type: Function,
            default: () => {}
        }
    },
    data() {
        return {
            buttons: [
                { type: 'zx', src: require('../../../assets/image/action-zx.png'), alt: '正向证据' },
                { type: 'fx', src: require('../../../assets/image/action-fx.png'), alt: '负向证据' },
                { type: 'jl', src: require('../../../assets/image/action-jl.png'), alt: '交流' },
                { type: 'pj', src: require('../../../assets/image/action-pj.png'), alt: '评价' }
            ]
        }
    },
    methods: {
        handleButtonClick(type) {
            if (this.onClick) {
                this.onClick(type);
            } else {
                console.log(`按钮点击: ${type}`);
            }
        }
    }
}
</script>
<style lang="less" scoped>
.buttons {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: flex-end;

    .action-btn {
        width: 34px;
        height: 34px;
        margin-left: 10px; /* 添加图片间距 */
        cursor: pointer;
        transition: opacity 0.2s;

        &:hover {
            opacity: 0.8;
        }
    }
}
</style>